import { DevWrapperComponentModule } from '../../../components/dev-wrapper/dev-wrapper.module';
import { FlxCommonsModule } from "@questrade/flx-commons";
import { FlxDoclistComponentModule } from '../../../components/flx-doclist/flx-doclist.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SdkJavascriptPage } from './sdk-javascript';

@NgModule({
    declarations: [
        SdkJavascriptPage
    ],
    imports: [
        DevWrapperComponentModule,
        FlxCommonsModule,
        FlxDoclistComponentModule,
        IonicPageModule.forChild(SdkJavascriptPage)
    ],
    exports: [
        SdkJavascriptPage
    ]
})
export class SdkJavascriptPageModule { }



// WEBPACK FOOTER //
// ./src/pages/sdk/sdk-javascript/sdk-javascript.module.ts